import NProgress from 'nprogress';
import { useEffect, useMemo } from 'react';

//
import StyledProgressBar from './styles';

const ProgressBar = () => {
  NProgress.configure({
    showSpinner: false,
  });

  useMemo(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    NProgress.done();
  }, []);

  return <StyledProgressBar />;
};

export default ProgressBar;
